const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/reset-password/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { buildPrivatePageMetaTags } from "@/lib/seo-meta";
import { getRootLoaderData } from "@/types/intl";
interface ResetPasswordSearch {
  token?: string;
  error?: string;
}
export const Route = createFileRoute("/_app/reset-password/")({
  head: ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const tMeta = createTranslator({
      locale,
      messages,
      namespace: "globals.metadata"
    });
    return {
      meta: buildPrivatePageMetaTags(tMeta("resetPassword"))
    };
  },
  validateSearch: (search: Record<string, unknown>): ResetPasswordSearch => ({
    token: typeof search.token === "string" ? search.token : undefined,
    error: typeof search.error === "string" ? search.error : undefined
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});